<script>
import { mapState } from 'vuex';
export default {
    name: "menus",
    data() {
        return {
            // menu: [
            //     { image: require('@/assets/images/study_01.jpg'), name: 'Master Degree' },
            //     { image: require('@/assets/images/study_02.jpg'), name: 'Bachelor Degree' },
            //     { image: require('@/assets/images/study_03.jpg'), name: 'Postgraduate Diploma' },
            //     { image: require('@/assets/images/study_04.jpg'), name: 'Undergraduate Diploma' },
            //     { image: require('@/assets/images/study_05.jpg'), name: 'Foundation Diploma' },
            // ]
        };
    },
    computed: {
        ...mapState(['studyMenu'])
    },
    components: {
        
    },
    mounted() {
        this.$store.dispatch('getCategory');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="menus">
        <div class="images flex justify_center">
            <div class="item" v-for="(item, index) in studyMenu" :key="index">
                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
            </div>
        </div>
        <div class="list layout_main flex">
            <router-link class="item flex_center" v-for="(item, index) in studyMenu" :key="index" :to="`/study/list?id=${item.id}`">{{ item.name }}</router-link>
        </div>
    </div>
</template>

<style scoped lang="scss">
.menus{
    padding: .8rem 0;
}
.images{
    margin-bottom: .8rem;
    @media only screen and (max-width: 750px) {
        display: none;
    }
    .item{
        width: 3.05rem;
        height: 2.7rem;
    }
}
.list{
    gap: .2rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
    }
    .item{
        height: .38rem;
        flex-grow: 1;
        font-size: .16rem;
        color: var(--background-color);
        font-weight: 600;
        border: 2px solid var(--background-color);
        border-radius: .38rem;
        line-height: 2;
        @media only screen and (max-width: 750px) {
            height: .6rem;
            font-size: .28rem;
            border-radius: .6rem;
        }
    }
}
</style>